module.exports = __webpack_public_path__ + "1040af66757e1e941ae5520c20beb9f3.svg";